import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { mutatorAction } from 'satcheljs';

export const createNewSpamItem = mutatorAction(
    'createNewSpamItem',
    (spamScenarioId: SpamScenarioId) => {
        const store = getSpamScenarioStore(spamScenarioId);
        store.newSpamItem = '';
    }
);

export const clearNewSpamItem = mutatorAction(
    'clearNewSpamItem',
    (spamScenarioId: SpamScenarioId) => {
        // Index -1 means we are not editing
        const store = getSpamScenarioStore(spamScenarioId);
        store.newSpamItem = null;
        store.indexToEdit = -1;
    }
);

export const setSpamListIndexToEdit = mutatorAction(
    'setSpamListIndexToEdit',
    (spamScenarioId: SpamScenarioId, indexToEdit: number) => {
        const store = getSpamScenarioStore(spamScenarioId);
        store.indexToEdit = indexToEdit;
    }
);
